// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MN6e","largestCol":"styles_largestCol__XzjEL","smallestCol":"styles_smallestCol__3CYmi"};